export default "__VITE_ASSET__b3b4c8b3__"